<template>
    <div class="used-item">
        <span class="item-title">{{ item_name}}</span>
        <span style="float: right;">可用 {{(qty-already_used)}}/已用 {{already_used}}</span>
        <van-grid :column-num="3" class="grid">
            <van-grid-item
                v-for="item in allData"
                :key="item.id"
                :class="item.flag ? 'info-focus-back-color' : 'info-back-color'"
            >
                <div>
                    {{item.value | moment("YY-MM-DD HH:mm") }}
                </div>
            </van-grid-item>
        </van-grid>
    </div>
</template>

<script>
import { Panel, Cell, Card, Tag, Button, Row, Col, Popup, CellGroup, Field, Loading, Grid, GridItem } from 'vant'
export default {
    name: "PackageUsedItem",
    components: {
        [Panel.name]: Panel,
        [Cell.name]: Cell,
        [Card.name]: Card,
        [Tag.name]: Tag,
        [Button.name]: Button,
        [Row.name]: Row,
        [Col.name]: Col,
        [Popup.name]: Popup,
        [CellGroup.name]: CellGroup,
        [Field.name]: Field,
        [Loading.name]: Loading,
        [Grid.name]: Grid,
        [GridItem.name]: GridItem
    },
    props: [ 'item_name', 'service_date', 'qty', 'already_used' ],
    data() {
        return {}
    },
    computed: {
        allData() {
            console.log(this.qty)
            console.log(this.service_date)
            const result = []
            for (var i=0; i<this.qty ;i++) {
                if (this.service_date.length>i)
                {
                    result.push({
                        key: i,
                        value: this.service_date[i],
                        flag: true
                    })
                } else {
                    result.push({
                        key: i,
                        value: '',
                        flag: false
                    })
                }
            }
            return result
        }
    }
}
</script>

<style scoped lang="less">
.used-item {
    .item-title {
        padding-left: 1em;
        margin-bottom: 8px;
        margin-top: 1em;
        font-size: 1em;
    }

    .grid {
        width: 100%;
        margin-left: 0.5em;
        margin-right: 0.5em;
    }
}
</style>


<style lang="less">
.grid {
    width: 100%;

    .van-grid-item__content {
        background-color: unset;
        border: 1px solid #FFF;
        height:2em;
        font-size: 0.8em;
    }
}
</style>